export enum TransactionsStatus {
  FAILED = 'failed',
  PENDING = 'pending',
  COMPLETED = 'completed',
}
